import React from 'react';

// import components
import TestiSlider from './TestiSlider';
import Jello from 'react-reveal/Jello';

const Testimonials = () => {

  return (
    <section id='testimonials' className='section bg-secondary'>
      <div className='container mx-auto'>
        <div className='flex flex-col items-center text-center'>
          <Jello>
            <h2 className='section-title before:content-testimonials relative before:absolute before:opacity-40 before:-top-[2rem] before:-left-64 before:hidden before:lg:block'>
              What other people say
            </h2>
            <p className='pb-20 max-w-5xl'>
              Discover what clients and colleagues say about working with me. These testimonials highlight my dedication to delivering high-quality web solutions, my commitment to meeting deadlines, and my professional approach as a full-stack developer.
            </p>
          </Jello>
        </div>

        <TestiSlider />
      </div>
    </section>
  );
};

export default Testimonials;
